import { render, staticRenderFns } from "./payGateWay.vue?vue&type=template&id=b06c77a4&scoped=true&"
import script from "./payGateWay.vue?vue&type=script&lang=js&"
export * from "./payGateWay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06c77a4",
  null
  
)

export default component.exports